const CrossIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='10'
      height='10'
      viewBox='0 0 10 10'
      fill='none'
    >
      <rect
        x='9.23242'
        width='1.08785'
        height='13.0542'
        transform='rotate(45 9.23242 0)'
        fill='black'
      />
      <rect
        x='10'
        y='9.23071'
        width='1.08785'
        height='13.0542'
        transform='rotate(135 10 9.23071)'
        fill='black'
      />
    </svg>
  );
};

CrossIcon.displayName = 'CrossIcon';
export default CrossIcon;
